/* global google */
import React, { Component } from 'react';
import debounce from 'lodash/debounce';

import { translateKey } from '_translations';

class MapSearch extends Component {
  constructor() {
    super();

    this.state = {
      searchTerm: '',
      autocompleteResults: [],
    };
  }
  render() {
    return (
      <div className="map-search">
        <span className="icon icon--search"></span>
        <input type="Text" placeholder={translateKey('Thunderbolt.Map.SearchPlaceholder')} value={this.state.searchTerm} onChange={this.handleUserInput} onKeyDown={this.handleKeyPress} />
        <span className="icon icon--location" onClick={this.props.promptUserLocation}></span>
        <div className="map-search-typeahead">
          {this.state.autocompleteResults.length > 0 &&
            (
              <ul>
                {this.state.autocompleteResults.map((result, index) =>
                  <li
                    key={index}
                    onClick={() => this.handleAutocompleteClick(result)}
                    dangerouslySetInnerHTML={{ __html: this.getFormattedDescription(result) }}>
                  </li>)}
              </ul>
            )
          }
        </div>
      </div>
    );
  }

  handleUserInput = (event) => {
    this.setState({
      searchTerm: event.target.value,
    }, this.doLocationLookup);
  }

  doLocationLookup = debounce(() => {
    const service = new google.maps.places.AutocompleteService();
    if (this.state.searchTerm.length > 2) {
      service.getPlacePredictions({ input: this.state.searchTerm }, this.bindSearchResults);
    } else {
      this.bindSearchResults([]);
    }
  }, 275);

  handleAutocompleteClick = (result) => {
    this.setState({
      autocompleteResults: [],
      searchTerm: result.description,
    });
    this.props.setMapToPlace(result);
  }

  handleKeyPress = (e) => {
    if (e.keyCode !== 13) {
      return;
    }

    if (this.state.autocompleteResults.length > 0) {
      this.handleAutocompleteClick(this.state.autocompleteResults[0]);
    } else if (this.state.searchTerm === null || this.state.searchTerm === '' || this.state.searchTerm === undefined) {
      this.props.setMapToMarkerLocation();
    }
  }

  bindSearchResults = (results) => {
    if (results === null) {
      results = [];
    }

    this.setState({
      autocompleteResults: results,
    });
  }

  getFormattedDescription = (result) => {
    const chars = result.description.split('');

    for (let i = 0; i < result.matched_substrings.length; i += 1) {
      const match = result.matched_substrings[i];

      chars[match.offset] = `<span>${chars[match.offset]}`;

      let unhighlighted = chars[match.offset + match.length];
      if (unhighlighted === undefined || unhighlighted === null) {
        unhighlighted = '';
      }

      chars[match.offset + match.length] = `</span>${unhighlighted}`;
    }

    return chars.join('');
  }
}

export default MapSearch;
